<template>
    <div id="list-businessTypes-component" class="w-full h-full flex flex-col">
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Tipo de negocio"
            :options="businessTypeOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { businessTypesCodes } from "@/common/fields/business-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "BusinessTypeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        businessTypeOptions() {
            return Object.entries(businessTypesCodes).map(([key, value]) => ({
                label: value,
                value: key
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
